import React from 'react';
import { useGet, useLastResolved } from 'ccstate-react';
import { fileExplorerState } from '../state/fileExplorerState';
import FileCard from './FileCard';
import type { FileItem } from '../../common/schema/schemaType';
interface FileGridProps {
    onFileRightClick?: (file: FileItem, event: React.MouseEvent) => void;
}
export default function FileGrid({ onFileRightClick }: FileGridProps) {
    const searchQuery = useGet(fileExplorerState.searchQuery$);
    const selectedFileIds = useGet(fileExplorerState.selectedFileIds$);
    const currentFiles = useLastResolved(fileExplorerState.currentFiles$) || [];
    const searchResults = useLastResolved(fileExplorerState.searchResults$);
    const displayFiles = (searchQuery as string).trim() ? ((searchResults as any)?.files || []) : currentFiles;
    if (displayFiles.length === 0) {
        return (<div className="flex-1 flex items-center justify-center" data-testid="empty-state" data-id="lo9e5p">
        <div className="text-center" data-id="29hixr">
          <div className="w-24 h-24 mx-auto mb-4 bg-[#F0F4F8] rounded-full flex items-center justify-center" data-id="mh4f53">
            <div className="w-12 h-12 text-[#B8C1CC]" data-id="gyr8wh">
              📁
            </div>
          </div>
          <h3 className="text-lg font-semibold text-[#1A2B3D] mb-2" data-id="gncb61">
            {(searchQuery as string).trim() ? 'No files found' : 'This folder is empty'}
          </h3>
          <p className="text-[#8B99A8] mb-6" data-id="odhmob">
            {(searchQuery as string).trim()
                ? `No files match "${searchQuery}"`
                : 'Upload files or create folders to get started'}
          </p>
          {!(searchQuery as string).trim() && (<div className="flex gap-3 justify-center" data-id="nq95px">
              <button className="flex items-center gap-2 px-4 py-2 bg-[#4A90E2] text-white rounded-md hover:bg-[#3A7AC8]" data-id="xcdsh4">
                Upload Files
              </button>
              <button className="flex items-center gap-2 px-4 py-2 bg-transparent text-[#4A90E2] border border-[#4A90E2] rounded-md hover:bg-[#E8F2FC]" data-id="hj7nvh">
                Create Folder
              </button>
            </div>)}
        </div>
      </div>);
    }
    return (<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-4 p-6" data-testid="file-grid" data-id="cmtshy">
      {displayFiles.map((file: any) => (<FileCard key={file.id} file={file} isSelected={(selectedFileIds as string[]).includes(file.id)} onRightClick={(e) => onFileRightClick?.(file, e)} data-id="pdm9ct"/>))}
    </div>);
}
